import { z } from "zod";

const addPlaylistSchema = z.object({
  name: z.string().min(1, { message: "Name is required" }),
  isPublic: z.boolean().optional(),
});
type AddPlaylistFormData = z.infer<typeof addPlaylistSchema>;

export { addPlaylistSchema };
export type { AddPlaylistFormData };
